import Input from "./input";
import TextArea from "./textArea";
import InputView from "./inputView";
import FormBuilderView from "./formBuilderView";
import NumberInput from "./numberInput";
import Checkbox from "./checkbox";
import Upload from "./upload";
import ColorPicker from "./colorPicker";
import Dropdown from "./dropdown";
import Autocomplete from "./autocomplete";
import { ImageUploadInput } from "./imageUploadInput";

export default {
  Input,
  InputView,
  FormBuilderView,
  TextArea,
  NumberInput,
  Checkbox,
  Upload,
  ColorPicker,
  Dropdown,
  Autocomplete,
  ImageUploadInput,
};
